// extracted by mini-css-extract-plugin
export default {"movies__wrapper":"Movies_movies__wrapper__jruci","movies__list":"Movies_movies__list__jh41l"};